import { render, staticRenderFns } from "./agv-ordering-selector.vue?vue&type=template&id=324c9508&scoped=true&lang=pug&"
import script from "./agv-ordering-selector.vue?vue&type=script&lang=js&"
export * from "./agv-ordering-selector.vue?vue&type=script&lang=js&"
import style0 from "./agv-ordering-selector.vue?vue&type=style&index=0&id=324c9508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324c9508",
  null
  
)

export default component.exports